import { IKioskProductsAndPackages } from '../../features/kiosk/core/interfaces/IKioskProductsAndPackages';
import { IShowPriceCategory } from '../../features/shows/core/interfaces/IShowPriceCategory';
import { ISeatPackageSelection } from '../interfaces/ISeatPackageSelection';
import { ISeatSelection } from '../interfaces/ISeatSelection';

export class PackageUtils {

  public static canAutoSelectPackage(
    seatSelection: ISeatSelection,
    priceCategory: IShowPriceCategory,
    kioskProductsAndPackages: IKioskProductsAndPackages | null
  ): boolean {
    if (!kioskProductsAndPackages) {
      return false;
    }

    const availablePackages = priceCategory.packages.filter(
      pkg => pkg.priceAreaId === seatSelection.priceAreaId
    );

    if (availablePackages.length !== 1) {
      return false;
    }

    const singlePackage = availablePackages[0];
    const fPackage = kioskProductsAndPackages.package.find(
      x => x.id === singlePackage.id
    );

    if (!fPackage) {
      return false;
    }

    const uniqueGroupingNrs = [...new Set(fPackage.packageContent.map(x => x.groupingNr))];

    return uniqueGroupingNrs.length === 1;
  }

  public static canAutoSelectPackagesForAllSeats(
    seatSelections: ISeatSelection[],
    priceCategory: IShowPriceCategory,
    kioskProductsAndPackages: IKioskProductsAndPackages | null
  ): boolean {
    return seatSelections.every(seatSelection =>
      this.canAutoSelectPackage(seatSelection, priceCategory, kioskProductsAndPackages)
    );
  }

  public static getAutoSelectedPackages(
    seatSelections: ISeatSelection[],
    priceCategory: IShowPriceCategory,
    kioskProductsAndPackages: IKioskProductsAndPackages
  ): ISeatPackageSelection[] {
    return seatSelections.map(seatSelection => {
      const singlePackage = priceCategory.packages.find(
        pkg => pkg.priceAreaId === seatSelection.priceAreaId
      );
      const fPackage = kioskProductsAndPackages.package.find(
        x => x.id === singlePackage.id
      );

      return {
        seat: seatSelection,
        package: singlePackage,
        selectedProductIds: fPackage.packageContent.map(x => x.productId)
      };
    });
  }
}

